import { PropTypes } from "prop-types"
import { components } from "react-select"
import classNames from "classnames"

import Field from "../Field"

export function SelectControl(props) {
  const { selectProps, menuIsOpen } = props

  return (
    <div className={classNames("oj-select-control", { "is-open": menuIsOpen })}>
      <Field>
        <Field.Label
          inputId={selectProps.inputId}
          label={selectProps.label}
          required={selectProps.required}
        />
        <Field.Input
          id={selectProps.inputId}
          readOnly={selectProps.readOnly}
          required={selectProps.required}
          disabled={selectProps.disabled}
          error={selectProps.error}
        >
          {innerProps => <components.Control {...props} {...innerProps} />}
        </Field.Input>
      </Field>
    </div>
  )
}

SelectControl.propTypes = {
  menuIsOpen: PropTypes.bool,
  selectProps: PropTypes.shape({
    disabled: PropTypes.bool,
    error: PropTypes.object,
    inputId: PropTypes.string,
    label: PropTypes.node,
    readOnly: PropTypes.bool,
    required: PropTypes.bool
  })
}

export default SelectControl
